'use es6';

import { getUserAttributes, setUserAttribute } from 'tinymce-data/api/User';
function initApiPlugin() {
  return {
    getUserAttributes: getUserAttributes(),
    setUserAttribute: setUserAttribute()
  };
}
export default initApiPlugin;